import React from "react"
import { Link } from "gatsby"
import IconButton from "./icon-button"
import { Share, Home } from "./icons"

function share() {
  if (navigator.share) {
    navigator
      .share({
        title: "Kaching",
        text: "Kaching",
        url: window.location.href,
      })
      .then(() => console.log("Successful share"))
      .catch(error => console.log("Error sharing", error))
  }
}

const ShareFooter = () => {
  return (
    <footer>
      <Link to="/">
        <IconButton icon={<Home />} />
      </Link>
      <IconButton icon={<Share />} onClick={() => share()} />
    </footer>
  )
}

export default ShareFooter
